export const zipCodeStringParser = (zipCode: string) => {
  const zipCodeDashIndex = 5;

  return zipCode.indexOf('-') === zipCodeDashIndex
    ? zipCode
    : `${zipCode.slice(0, zipCodeDashIndex)}-${zipCode.slice(zipCodeDashIndex)}`;
};
